import { Menu, IndexPath } from '@ui-kitten/components';
export { IndexPath };
export default Menu;
//# sourceMappingURL=Menu.js.map